import {

  GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID,
  GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID_SUCCESS,
  HOSTED_PAGE_DO_PAYMENT,
  HOSTED_PAGE_DO_PAYMENT_SUCCESS,
  CHECK_BIN_CARD_NUMBER,
  CHECK_BIN_CARD_NUMBER_SUCCESS,
  CHECK_BIN_CARD_NUMBER_FAIL,
  HOSTED_PAYMENT_CLEAR_CHECK_BIN_ERROR,
  HOSTED_PAYMENT_PAGE_API_ERROR
} from "./actionTypes"


export const getPaymentPageTransactionByUniqueId = paymentPageTransactionFilter => ({
  type: GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID,
  payload: paymentPageTransactionFilter,
})

export const getPaymentPageTransactionByUniqueIdSuccess = paymentPageTransactionFilter => ({
  type: GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID_SUCCESS,
  payload: paymentPageTransactionFilter,
})

export const hostedPageDoPayment = record => ({
  type: HOSTED_PAGE_DO_PAYMENT,
  payload: record,
})

export const hostedPageDoPaymentSuccess = record => ({
  type: HOSTED_PAGE_DO_PAYMENT_SUCCESS,
  payload: record,
})

export const checkBinCardNumber = record => ({
  type: CHECK_BIN_CARD_NUMBER,
  payload: record,
})

export const checkBinCardNumberSuccess = record => ({
  type: CHECK_BIN_CARD_NUMBER_SUCCESS,
  payload: record,
})

export const checkBinCardNumberFail = error => ({
  type: CHECK_BIN_CARD_NUMBER_FAIL,
  payload: error,
})

export const clearHostedPaymentCheckBinError = () => ({
  type: HOSTED_PAYMENT_CLEAR_CHECK_BIN_ERROR,
})

export const hostedPaymentPageApiError = error => {
  return {
    type: HOSTED_PAYMENT_PAGE_API_ERROR,
    payload: error,
  }
}